(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartExportController', ChartExportController);

    ChartExportController.$inject = ['$scope', 'ChartExport', 'GenericEntityDatatableService', 'CoreService',
        '$uibModal', '$q', 'ConfirmationService', '$state'];

    function ChartExportController($scope, ChartExport, GenericEntityDatatableService, CoreService,
                                   $uibModal, $q, ConfirmationService, $state) {
        var vm = this;

        var params = {
            sort: 'id,desc',
            size: 10
        };

        vm.descriptor = {
            title: 'Chart Export',
            newButtonTitle: 'New Export',
            entityClassHumanized: 'Chart Export',
            entityStateName: 'chart-export',
            service: ChartExport,
            serviceMethod: 'query',
            params: params,
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: 'id',
                    title: 'ID'
                },
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'status',
                    title: 'Status',
                },
                {
                    name: 'charts',
                    title: 'Charts',
                },
                {
                    name: 'progress',
                    title: 'Progress',
                },
                {
                    name: 'completed',
                    title: 'Completed',
                    render: function (entity) {
                        return entity.progress - entity.fails;
                    }
                },
                {
                    name: 'fails',
                    title: 'Fails',
                },
                {
                    name: 'facility.name',
                    title: 'Facility',
                    render: function (entity) {
                        return entity.facility.name;
                    }
                },
                {
                    name: 'facesheetTpl.id',
                    title: 'Facesheet ID',
                    render: function (entity) {
                        return entity.facesheetTpl.id;
                    }
                },
                {
                    name: 'facesheetTpl.name',
                    title: 'Facesheet',
                    render: function (entity) {
                        return entity.facesheetTpl.name;
                    }
                }
            ],
            rowActions: [
                {
                    name: 'View',
                    action: function (data) {
                        return view(data.id);
                    },
                    aClass: 'dd-link blue',
                    iClass: 'fa fa-eye',
                },
                {
                    name: 'Stop',
                    action: function (data) {
                        return cancel(data.id);
                    },
                    aClass: 'dd-link red',
                    iClass: 'fa fa-trash-o',
                    ngIf: function (entity) {
                        return entity.status === 'PENDING' ||
                        entity.status === 'STARTED';
                    },
                }
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Export',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                },
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/chart-export/chart-export-dialog.html',
                controller: 'ChartExportDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Acuity').result.then(function () {
                    ChartExport.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function cancel(id) {
            var config = {
                title: 'Cancel Chart Export',
                message:
                    `Are you sure you want to <strong>STOP</strong> this Chart Export ${id}?`,
                icon: {},
                leftAction: null,
                actions: [
                    {
                        name: 'Stop',
                        color: 'btn btn-success',
                        icon: 'fa fa-trash',
                        value: 'SUCCESS'
                    },
                    {
                        name: 'Cancel',
                        color: 'btn btn-danger',
                        icon: 'fa fa-ban',
                        value: 'CANCEL'
                    }
                ]
            }

            return $q(function (resolve) {
                ConfirmationService.open(config).result.then(function () {
                    ChartExport.cancel({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function view(id) {
            $state.go('chart-export-file', {id: id});
        }
    }
})();
